import {
  SET_HIVER_CONFIG,
  UPDATE_HIVER_CONFIG,
  CLEAR_HIVER_CONFIG
} from '../types';
import HiverApi from 'widget/api/hiver';
import { sendExceptionToSentry } from 'shared/helpers/sentry';
import { initGainSight } from '../../../gainSightIntegration';

const state = {
  hiverConfig: {
    show_contact_form: false,
    show_hiver_branding: false,
    is_workflow_enabled: false,
    bot_icon: '',
    bot_name: '',
    live_chat_customisation_feature_access: false,
    prechat_country_code_feature_access: false,
    surface_kb_feature_access: false,
    script_loaded_on_webpage: true,
    knowledge_base: {
      enabled: false,
      id: null
    }
  }
};

export const getters = {
  getHiverConfig: $state => $state.hiverConfig
};

export const actions = {
  fetchHiverConfig: async ({ commit }, websiteToken) => {
    try {
      const { data } = await HiverApi.getHiverConfig(websiteToken);
      if (data?.gainsight_enabled) {
        initGainSight(data?.tenant || 'GMAIL');
      }
      window.aptrinsic?.('identify', {
        //User Fields
        id: data?.usergroup_id
      });
      commit(SET_HIVER_CONFIG, data);
    } catch (error) {
      sendExceptionToSentry(error);
    }
  },
  update({ commit }, data) {
    commit(UPDATE_HIVER_CONFIG, data);
  },
  clearConversationAttributes: ({ commit }) => {
    commit('CLEAR_HIVER_CONFIG');
  }
};

export const mutations = {
  [SET_HIVER_CONFIG]($state, data) {
    $state.hiverConfig = data;
  },
  [UPDATE_HIVER_CONFIG]($state, data) {
    $state.hiverConfig = data;
  },
  [CLEAR_HIVER_CONFIG]($state) {
    $state.hiverConfig = {};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
